export default __webpack_public_path__ + "media/cursors/zoom-out-df7c8991.cur";